// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1hpf5","right":"Footer_right__1Ru4r","buttons":"Footer_buttons__3_T_-"};